import { useServices } from 'app/hooks';

export const useSymbolsService = () => useServices().symbolsService;
